var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasOverlays
    ? _c(
        "div",
        { staticClass: "overlay", class: _vm.rootClasses },
        [
          _c("div", {
            staticClass: "overlay--backdrop",
            on: { click: _vm.onBackgroundClick }
          }),
          _vm._v(" "),
          _c(
            _vm.currentOverlay.component,
            _vm._b(
              {
                key: _vm.currentOverlay.id,
                tag: "component",
                staticClass: "overlay--content",
                attrs: { "overlay-id": _vm.currentOverlay.id }
              },
              "component",
              _vm.currentOverlay.args,
              false
            )
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-900416c6", { render: render, staticRenderFns: staticRenderFns })
  }
}